import { render, staticRenderFns } from "./TxPresenterBuilder.vue?vue&type=template&id=b4de26ca&scoped=true"
import script from "./TxPresenterBuilder.vue?vue&type=script&lang=js"
export * from "./TxPresenterBuilder.vue?vue&type=script&lang=js"
import style0 from "./TxPresenterBuilder.vue?vue&type=style&index=0&id=b4de26ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4de26ca",
  null
  
)

export default component.exports